import { useEffect, useRef } from "react";

interface ExamTimerProps {
  timeRemaining: number;
  onTick: (seconds: number) => void;
  onTimeUp: () => void;
}

export default function ExamTimer({ timeRemaining, onTick, onTimeUp }: ExamTimerProps) {
  const intervalRef = useRef<ReturnType<typeof setInterval> | null>(null);

  useEffect(() => {
    intervalRef.current = setInterval(() => {
      onTick(timeRemaining - 1);
    }, 1000);

    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
      }
    };
  }, [timeRemaining, onTick]);

  useEffect(() => {
    if (timeRemaining <= 0) {
      onTimeUp();
    }
  }, [timeRemaining, onTimeUp]);

  const minutes = Math.floor(timeRemaining / 60);
  const seconds = timeRemaining % 60;
  const isWarning = timeRemaining <= 300;
  const isCritical = timeRemaining <= 60;

  return (
    <div
      className={`flex items-center space-x-2 rounded-lg px-4 py-2 font-mono text-lg font-bold ${
        isCritical
          ? "bg-danger-100 text-danger-700 animate-pulse"
          : isWarning
            ? "bg-danger-50 text-danger-600"
            : "bg-gray-100 text-gray-700"
      }`}
    >
      <svg className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
      </svg>
      <span>
        {String(minutes).padStart(2, "0")}:{String(seconds).padStart(2, "0")}
      </span>
    </div>
  );
}
